/** ***********
*
* <aircraft-planning.module.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
 * All rights reserved.
**************/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AircraftPlanningComponent } from './aircraft-planning/aircraft-planning.component';
import { DialogUploadPlanningComponent,  } from './dialog/upload-planning-dialog/dialog-upload-planning.component';
import { AppMaterialModule } from 'src/app/material.modules';
import { SharedTranslationModule } from '../shared/shared-translation.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { FilterModule } from '../filter/filter.module';
import { DialogEditAircraftPlanningComponent } from './dialog/dialog-edit-aircraft-planning/dialog-edit-aircraft-planning.component';
import { PlanningCountKeyvaluePipe } from './aircraft-planning/planning-count-keyvalue.pipe';
import { RouterModule } from '@angular/router';
import { scopeGuard } from 'src/app/auth/scope.guard';
import { TranslateModule } from '@ngx-translate/core';
import { hasContextGuard } from 'src/app/auth/has-context.guard';

@NgModule({
  declarations: [
    AircraftPlanningComponent,
    DialogEditAircraftPlanningComponent,
    DialogUploadPlanningComponent,
    PlanningCountKeyvaluePipe,
  ],
  imports: [
    CommonModule,
    SharedTranslationModule,
    SharedModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FilterModule,
    TranslateModule.forChild({ extend: true }),
    RouterModule.forChild([
        {
            path: '',
            component: AircraftPlanningComponent,
            canActivate: [scopeGuard, hasContextGuard],
            data: { role: 'act' },
        },
    ]),
  ]
})
export class AircraftPlanningModule { }
